/**
 * A MASZK VISSZAJELZÉSE AZ ADMINBAN (#76) — a váz szintjén, a NAV-szinkron
 * és a Tensoft közleménye mellett: a művelet globális, a visszajelzése is az.
 *
 * Három állapot, és mindhárom teendőt mond, nem csak állapotot:
 *   • hiba — a szerver mondata (403: nincs jogod / a cég nem érhető el);
 *   • elnyelt lap — a link, amíg a kód él;
 *   • nyitott munkamenet — melyik cég nevében, meddig, és a lezárás gombja.
 *     Egy elfelejtett, másik lapon nyitva hagyott maszk így nem láthatatlan.
 */

import { useTranslation } from 'react-i18next';
import { formatDateTime } from '@/i18n/generated';
import type { ImpersonationHook } from './useImpersonation';

export function ImpersonationNotice({ impersonation }: { impersonation: ImpersonationHook }) {
  const { t } = useTranslation();
  const { error, blockedHandoff, active, busy } = impersonation;

  if (error !== null) {
    return (
      <div className="notice" role="alert">
        <p>{error}</p>
        <button type="button" onClick={impersonation.dismiss}>
          {t('impersonation.dismiss')}
        </button>
      </div>
    );
  }

  if (blockedHandoff !== null) {
    return (
      <output className="notice">
        <p>{t('impersonation.blocked')}</p>
        <a href={blockedHandoff} target="_blank" rel="noopener noreferrer">
          {t('impersonation.openTab')}
        </a>
      </output>
    );
  }

  if (active !== null) {
    return (
      <output className="notice">
        <p>
          {t('impersonation.active', {
            company: active.companyName,
            until: formatDateTime(active.expiresAt),
          })}
        </p>
        <button type="button" disabled={busy} onClick={impersonation.end}>
          {t('impersonation.end')}
        </button>
      </output>
    );
  }

  return null;
}
